
  <dw-content>
    <form dw-form [formGroup]="addForm" (ngSubmit)="addData()" class="fx_modal_form">
      <dw-form-input
        formControlName="label"
        dwLabel="{{'com-常用条件名称' | translate}}"
        dwLabelSpan="6"
        dwInputSpan="18"
        [dwRequired]="true">
      </dw-form-input>
      <dw-form-item dw-row>
        <div dw-col [dwSpan]="6">
        </div>
        <dw-form-control dw-col [dwSpan]="18">
          <label dw-checkbox formControlName="aan005" >
            <span>{{ 'com-默认查询条件' | translate}}</span>
          </label>
        </dw-form-control>
      </dw-form-item>
      <div class="customize-footer">
        <button dw-button type="button" [dwType]="'default'" (click)="handleCancel()">{{ 'dw-cancel' | translate}}</button>
        <button dw-button [dwType]="'primary'" [disabled]="!addForm.valid">{{ 'dw-determine' | translate}}</button>
      </div>
    </form>
  </dw-content>
  